import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import AppStore from '../../../store/AppStore'
import DtoUser from '../../../home/dto/DtoUser'
import { createDtoFilter, createDtoFilterTheme } from '../../../utils/ResearchTypesUtils'
import DtoFilterType from '../../../referential/dto/DtoFilterType'
import { connect } from 'react-redux'
import DtoStation from '../../../sites/dto/DtoStation'
import SelectionAction from '../../../dashboard/actions/SelectionAction'
import DtoSelectionRow from '../../../dashboard/dto/DtoSelectionRow'
import DtoUserCredit from '../../../home/dto/DtoUserCredit'
import DtoLayer from '../../../administration/dto/DtoLayer'
import { filter, intersectionWith } from 'lodash'
import Chip from '@material-ui/core/Chip'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { css } from 'glamor'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import ToastrAction from '../../../home/actions/ToastrAction'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ ref } { ...props } />
})

class SelectionSaveModal extends Component {

	constructor(props) {
		super(props)
	}

	validate = () => {
		const title = this.refs.titleSelection.value
		const finalWaterShed = (() => {
			return intersectionWith(this.props.watershedSelected, filter(this.props.watershedLayers, (o) => {
				return o.visibility
			}), (a, b) => {
				return a.id == b.id
			})
		})()
		if (!title) {
			AppStore.dispatch(ToastrAction.warning(i18n.warning.pleaseTitleInform))
		} else if (!this.props.selectedStations.length) {
			AppStore.dispatch(ToastrAction.warning(i18n.warning.pleaseSiteSelection))
		} else {
			const filtersResearch = this.props.selectedFilters.map((o) => {
				return createDtoFilter(this.props.filterTypes, o)
			})
			const filtersTheme = this.props.selectedThemes.map((o) => {
				return createDtoFilterTheme(this.props.filterTypes, o)
			})
			const filters = [].concat(filtersResearch, filtersTheme)
			if (this.props.selectedSelection) {
				AppStore.dispatch(SelectionAction.updateSelection(this.props.selectedSelection.id, this.props.user.login, title, filters, this.props.selectedStations, finalWaterShed))
			} else {
				AppStore.dispatch(SelectionAction.saveSelection(this.props.user.login, title, filters, this.props.selectedStations, finalWaterShed))
			}
			AppStore.dispatch(SelectionAction.closeModalSelectionSave())
		}
	}

	creditAccount = () => {
		AppStore.dispatch(ToastrAction.warning(i18n.warning.pleaseRecreditAccount))
	}

	getInput = () => {
		if (this.props.selectedSelection) {
			return (<input id='titleSelection' type='text' ref='titleSelection'
						   placeholder={ i18n.saveSelectionPlaceholder }
						   defaultValue={ this.props.selectedSelection.title }/>)
		}
		return (
			<input id='titleSelection' type='text' ref='titleSelection' placeholder={ i18n.saveSelectionPlaceholder }
				   required/>)
	}

	getCredit = (totalCredit, isAvailable) => {
		const creditTitle = (() => {
			if (totalCredit > 1) {
				return i18n.simplePlurialCredit
			}
			return i18n.simpleCredit
		})()

		const titleTotalCredit = (<span>{ i18n.selectionCost } : { totalCredit } { creditTitle }</span>)
		const insufficientCredit = (() => {
			if (!isAvailable) {
				return (
					<Chip>
						{ i18n.insufficientCreditExport }
					</Chip>
				)
			}
			return null
		})()
		return (
			<div className='row no-margin'>
				<div className='col s8 no-padding'>
					{ titleTotalCredit }
				</div>
				<div className='col s2 no-padding'>
					{ insufficientCredit }
				</div>
			</div>
		)
	}
	getTitle = () => {
		if (this.props.modalSelectionSave) {
			return (
				<DialogTitle id='alert-dialog-slide-title'>{ i18n.saveTheSelection }</DialogTitle>
			)
		}
		return null
	}
	getContent = () => {
		if (this.props.modalSelectionSave) {
			return (
				<div>
					<div className={ 'row no-margin' }>
						<div className={ 'col l12 no-padding' }>
							<div className='input-field col s12'>
								{ this.getInput() }
							</div>
						</div>
					</div>
				</div>
			)
		}
		return null
	}
	handleClose = () => {
		AppStore.dispatch(SelectionAction.closeModalSelectionSave())
	}
	getDialogAction = () => {
		if (this.props.modalSelectionSave) {
			return (
				<DialogActions>
					<Button onClick={ this.handleClose } { ...css({ backgroundColor: 'red !important', color: 'white !important' }) }>
						{ i18n.cancel }
					</Button>
					<Button onClick={ this.validate } { ...css({ backgroundColor: '#53A1FF !important', color: 'white !important' }) } autoFocus>
						{ i18n.save }
					</Button>
				</DialogActions>
			)
		}
		return null
	}

	render() {
		return (
			<Dialog
				maxWidth='sm'
				fullWidth={ true }
				TransitionComponent={ Transition }
				modal={ false }
				keepMounted
				open={ this.props.modalSelectionSave }
				onClose={ this.handleClose }
			>

				{ this.getTitle() }
				{ this.getContent() }
				{ this.getDialogAction() }
			</Dialog>
		)
	}
}

SelectionSaveModal.propTypes = {
	user: PropTypes.objectOf(DtoUser),
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	selectedSelection: PropTypes.instanceOf(DtoSelectionRow),
	watershedSelected: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	watershedLayers: PropTypes.arrayOf(PropTypes.instanceOf(DtoLayer)),
	userCredit: PropTypes.instanceOf(DtoUserCredit),
	modalSelectionSave: PropTypes.bool
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		selectedFilters: store.AdministrationReducer.selectedFilters,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		filterTypes: store.ReferentialReducer.filterTypes,
		selectedStations: store.SitesReducer.selectedStations,
		selectedSelection: store.SelectionReducer.selectedSelection,
		modalSelectionSave: store.SelectionReducer.modalSelectionSave,
		watershedSelected: store.SitesReducer.watershedSelected,
		watershedLayers: store.SitesReducer.watershedLayers,
		userCredit: store.CreditReducer.userCredit
	}
}

export default connect(mapStateToProps)(SelectionSaveModal)



// WEBPACK FOOTER //
// ./src/components/modal/selection/SelectionSaveModal.js